import { render, staticRenderFns } from "./OtherRegulationsOutput.vue?vue&type=template&id=ca884924&"
import script from "./OtherRegulationsOutput.vue?vue&type=script&lang=js&"
export * from "./OtherRegulationsOutput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/apps/eneforhandler/components/contract/OtherRegulationsOutput.vue
// module id = null
// module chunks = 